import { gql } from '@apollo/client';

const getBookingProductByCode = gql`
  query GetProductByCode($code: String!, $filters: ProductFilters) {
    getProductByCode(code: $code, filters: $filters) {
      name
      id
      costs {
        cost
        costCurrency
        defaultTaxPercentage
        programme
        projectedCost
        reservationCost
        type
      }
      salePrices {
        programme
        salePrice
        salePriceCurrency
        stripePriceID
      }
      salesforceID
      status
      tier
      accessType
      category
      code
      location {
        city
        code
        country
        landside
        isoCountryCode
        name
        terminal
        type
      }
      partnerBrand {
        id
      }
      stage
      outlet {
        id
      }
      partnerIntegrationData {
        accessPeriod
        agreedPrebookHoldTime
        amendPeriodAllowed
        bookingFlowType
        bookingMaxPeriodAllowed
        bookingMinPeriodAllowed
        cancellationPeriodAllowed
        maxGuests {
          adult {
            isChargeable
            isPartySizeImpacted
            value
          }
          children {
            isChargeable
            isPartySizeImpacted
            value
          }
          infant {
            isChargeable
            isPartySizeImpacted
            value
          }
          partySize
          senior {
            isChargeable
            isPartySizeImpacted
            value
          }
        }
        partnerIntegrationID
        partnerProductID
        pdfGuideUrl
        stripeProductID
        timeSlotPeriod
      }
    }
  }
`;
export default getBookingProductByCode;
